// extracted by mini-css-extract-plugin
export default {"button":"theme-toggle-module_button-Plm9p"};